import React, { useState, useEffect, useRef, useCallback } from 'react';
import {useSelector} from 'react-redux'
import BannerNew from "../BannerNew/BannerNew";

import {
    BannerFonSt,
    ContainerTopBannerSt,
    AboutUsMoreDetailsSt,
    LeftSt,
    AboutUsTextSt,
    AboutUsTitleSt,
    ContainerSt,
    ButtonSt,
    ButtonPaddingSt,
    ArrowSt,
    BannersContainerSt,
    CarouselSt,
    PlugSt
} from './style.js';

import i18n from "i18next";

const TopBannerNew = ({ banners, contentType, plug, isMobile }) => {
    const [maxRight, setMaxRight] = useState(0);
    // margin-left у CarouselSt - за чет которого осуществляется листание карусели
    const [marginCount, setMarginCount] = useState(0);
    const [rightButtonDisplay, setRightButtonDisplay] = useState(false);
    const [leftButtonDisplay, setLeftButtonDisplay] = useState(false);
    // текст может быть недоступен если произойдет декомпозиция компонентов
    const channel = useSelector((state) => state.channelContent)
    // eslint-disable-next-line no-unused-vars
    const [lastCardLeftMargin, setLastCardLeftMargin] = useState(true);

    // ref - для получения ширины контейнара
    const bannerFonRef = useRef(null);
    const pageContent = channel.pageContent

    const timers = useRef([]);
    useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

    const carouselMoveRight = () => {
        let newMarginCount = marginCount + 1;
        if (banners.length - newMarginCount === maxRight) {
            setMarginCount(newMarginCount);
            setRightButtonDisplay(false);
            setLeftButtonDisplay(true);
        }
        else {
            setMarginCount(newMarginCount);
            setLeftButtonDisplay(true);
        }
    };

    const carouselMoveLeft = () => {
        let newMarginCount = marginCount - 1;
        if (newMarginCount === 0) {
            setMarginCount(newMarginCount);
            setLeftButtonDisplay(false);
            setRightButtonDisplay(true);
        }
        else {
            setMarginCount(newMarginCount);
            setRightButtonDisplay(true);
        }
    };

    // Движение карусели СВАЙПОМ
    const swipeZeroDot = useRef(0);
    const swipeBreak = useRef(true);

    // получение первой точки свайпа
    const swipeSlide = (e) => {
        swipeZeroDot.current = e.changedTouches[0].pageX;
    };

    //отработка горизонтального свайпа
    const swipeSlideEnd = (e) => {
        if (swipeBreak.current) {
            swipeBreak.current = false;
            let finalDot = swipeZeroDot.current - e.changedTouches[0].pageX;
            if (finalDot > 1 && rightButtonDisplay) {
                carouselMoveRight();
            }
            else if (finalDot < -1 && leftButtonDisplay) {
                carouselMoveLeft();
            }
            timers.current.push(setTimeout(() => { swipeBreak.current = true }, 300));
        }
    };

    const bannersLength = banners.length;

    const _maxRightCount = useCallback(() => {
        timers.current.push(setTimeout(() => {
            if (!bannerFonRef.current) return;

            const width = bannerFonRef.current.offsetWidth;
            let next = 0;

            if (width < 768 && bannersLength > 2) next = 2;
            else if (width < 1024 && bannersLength > 3) next = 3;
            else if (width < 1420 && bannersLength > 4) next = 4;
            else if (width < 1820 && bannersLength > 5) next = 5;
            else if (width >= 1820 && bannersLength > 6) next = 6;

            if (next) {
                setRightButtonDisplay(true);
                setMaxRight(next);
                setLastCardLeftMargin(false);
            }
        }, 300));
    }, [bannersLength]);

    // componentDidMount + componentDidUpdate по количеству баннеров
    useEffect(() => {
        _maxRightCount();
    }, [bannersLength, _maxRightCount]);

    // componentDidUpdate по isMobile: сбрасываем карусель
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        setMaxRight(0);
        setMarginCount(0);
        setRightButtonDisplay(false);
        setLeftButtonDisplay(false);
        _maxRightCount();
    }, [isMobile, _maxRightCount]);

    let PlugImg = (i18n.language === 'en') ? '/images/cover_event_null_EN.jpg' : '/images/cover_event_null_RU.jpg'

    const allBanners = banners.map((item, i) => {
        if (i === banners.length - 1) {
            return (
                <BannerNew {...item} key={i + 1} index={i} widthEl={banners.length} marginCount={marginCount} discriptionOpenLeft={true} contentType={contentType} lastCardLeftMargin={item.type} />
            )
        }
        else {
            return (
                <BannerNew {...item} key={i + 1} index={i} widthEl={banners.length} marginCount={marginCount} contentType={item.type} />
            )
        }
    })

    return (
        <BannerFonSt ref={bannerFonRef}>
            <ContainerTopBannerSt>
                <LeftSt>
                    {(contentType === "проект" || contentType === "project") && <>
                        <AboutUsTitleSt>{i18n.t(`topBanner.description.${0}.title`)}</AboutUsTitleSt>
                        <AboutUsTextSt dangerouslySetInnerHTML={{ __html: pageContent.data?.content.main?.aboutUsText }} />
                        <AboutUsMoreDetailsSt to={'/about'}>{i18n.t(`topBanner.detail`)}</AboutUsMoreDetailsSt>

                    </>}
                    {(contentType === "мероприятие" || contentType === "event") && <>
                        <AboutUsTitleSt>{i18n.t(`topBanner.description.${1}.title`)}</AboutUsTitleSt>
                        <AboutUsTextSt>{i18n.t(`topBanner.description.${1}.text1`)}</AboutUsTextSt>
                    </>}
                </LeftSt>
                <ContainerSt>

                    {(plug === 'true') ? <PlugSt style={{ backgroundImage: `url(` + PlugImg + `)` }} ></PlugSt>
                        : <>
                            <BannersContainerSt>
                                <CarouselSt widthEl={banners.length} marginCount={marginCount} onTouchStart={(e) => swipeSlide(e)} onTouchMove={(e) => swipeSlideEnd(e)}>
                                    {allBanners}
                                </CarouselSt>
                            </BannersContainerSt>
                            {leftButtonDisplay && <ButtonSt side="left" onClick={() => carouselMoveLeft()}>
                                <ButtonPaddingSt></ButtonPaddingSt>
                                <ArrowSt width="17" height="28" viewBox="0 0 17 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.668 3.79967L6.36658 13.9997L16.668 24.1997L13.4966 27.333L0.00131342 13.9997L13.4966 0.66634L16.668 3.79967Z" fill="white" />
                                </ArrowSt>
                            </ButtonSt>}
                            {rightButtonDisplay && <ButtonSt side="right" onClick={() => carouselMoveRight()}>
                                <ButtonPaddingSt></ButtonPaddingSt>
                                <ArrowSt width="17" height="28" viewBox="0 0 17 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.332027 24.2003L10.6334 14.0003L0.332031 3.80032L3.50342 0.666993L16.9987 14.0003L3.50341 27.3337L0.332027 24.2003Z" fill="white" />
                                </ArrowSt>
                            </ButtonSt>}
                        </>
                    }

                </ContainerSt>
            </ContainerTopBannerSt>
        </BannerFonSt>
    );
};

export default TopBannerNew;
